import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EN from "./en.json";
import NL from "./nl.json";

const fallbackLng = ["en", "nl"];
const availableLanguages = ["en", "nl"];

const resources = {
  en: {
    translation: EN,
  },
  nl: {
    translation: NL,
  },
};

i18n
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources,
    lng: "en",
    fallbackLng,
    keySeparator: ".",

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
  });

export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  localStorage.setItem("i18nextLng", lang); // Save language to localStorage
};

export default i18n;
